module.exports = __webpack_public_path__ + "static/media/deleteIcon.82e1d108.svg";